// src/components/Support.js
import React from "react";
import "./Support.css";

const Support = () => (
  <div className="support-container">
    <h2>Support</h2>
    <p>
      Need help? Shoot us an email at{" "}
      <a href="mailto:support@quickfit.com">support@quickfit.com</a> or fill out
      the form below and we’ll get back to you within 24 hours.
    </p>

    <form
      className="support-form"
      onSubmit={(e) => {
        e.preventDefault();
        // handle your submit logic
      }}
    >
      <input
        type="text"
        name="name"
        placeholder="Your Name"
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Your Email"
        required
      />
      <textarea
        name="message"
        placeholder="How can we help?"
        required
      />
      <button type="submit">Send Message</button>
    </form>
  </div>
);

export default Support;
